import React from 'react';
import { LeafDivider, Section } from './Shared';
import { costRows } from '../data/landing';
export const CostComparison = () => <Section className="max-w-4xl" data-id="element-37" data-mp="2avo33sv54nd7">
    <h2 className="text-[28px] md:text-5xl font-display font-bold leading-tight text-brand-purpleDark text-center" data-id="element-38" data-mp="2aumml8vcv8o3">
      ⚖️ ¿Cuánto cuesta no tenerlo?
    </h2>

    <div className="mt-10 rounded-3xl bg-white/85 border border-brand-purple/15 overflow-hidden" data-id="element-39" data-mp="21x2ils63yy9s">
      <div className="hidden md:grid grid-cols-2 gap-6 px-6 py-4 bg-brand-surfaceLight/70 border-b border-brand-purple/15" data-id="element-40" data-mp="2ykqu3rbnzskd">
        <p className="font-serif font-bold text-brand-purpleDark" data-id="element-41" data-mp="2uic84ycp8cov">
          Sin el Megapack Saberes Ancestrales
        </p>
        <p className="font-serif font-bold text-brand-burgundy" data-id="element-42" data-mp="2km957qa0wa0v">Costo real</p>
      </div>
      <ul className="divide-y divide-brand-purple/10" data-id="element-43" data-mp="2kon3s93ww4d6">
        {costRows.map(row => <li key={row.without} className="grid md:grid-cols-2 gap-1 md:gap-6 px-5 md:px-6 py-4" data-id="element-44" data-mp="1e3u6ib8f9gmb">
            <span className="text-[15px] md:text-base font-medium text-brand-text" data-id="element-45" data-mp="2la9cnv4czmt6">
              {row.without}
            </span>
            <span className="text-[15px] md:text-base text-brand-burgundy" data-id="element-46" data-mp="2pb2v48z189eo">
              <span className="md:hidden" aria-hidden="true" data-id="element-47" data-mp="2bdec76oizcc9">→ </span>
              {row.cost}
            </span>
          </li>)}
      </ul>
    </div>

    <LeafDivider className="mt-12" data-id="element-48" data-mp="2gdiwz8wgut8a" />

    <p className="text-center text-xl md:text-2xl font-display italic font-semibold text-brand-purpleDark max-w-3xl mx-auto" data-id="element-49" data-mp="21mjoryzjm6p8">
      "El terapeuta que tiene un sistema aplica con confianza. El que aplica con
      confianza genera resultados. El que genera resultados, crece." 🌿
    </p>
  </Section>;